<template>
  <div class="container">
    <head-top />
    <div class="content">
      <!-- 面包屑 -->
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }"> {{ $t('navbar.home') }} </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/exhibitsList' }">{{ $t('navbar.exhibits') }} </el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('exhibits.detailTitle') }} </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 商品型号轮播图 -->
      <div class="parduct_intr">
        <div class="lunbo">
          <!-- 轮播开始 -->
          <!--v-if判断一下，实现loop-->
          <swiper v-if="lunboImg.length >= 1" :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in lunboImg" :key="index">
              <img :src="item.url" alt="" />
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="introduce">
          <div class="title">
            <div class="titleContent">{{ lang=='zh'? exhibitInfo.exhibitsName: exhibitInfo.column25 }}</div>
            <div class="border"></div>
          </div>
          <p :title="exhibitInfo.column23">
            <span> {{ $t('exhibits.productModel') }}</span
            >{{ exhibitInfo.column23 }}
          </p>
          <p :title="exhibitInfo.seriesName">
            <span> {{ $t('exhibits.prosuctSeries') }} </span>{{ exhibitInfo.seriesName }}
          </p>
          <p :title="exhibitInfo.column17 + '/' + exhibitInfo.column18 + '/' + exhibitInfo.column19">
            <span> {{ $t('exhibits.productCategory') }} </span>{{ exhibitInfo.column17 }} / {{ exhibitInfo.column18 }} / {{ exhibitInfo.column19 }}
          </p>
          <div class="collent_btn">
            <button class="shoucang" @click="consult(exhibitorInfo)">{{ $t('common.consult') }}</button>
            <button class="shoucang3" @click="collent(exhibitInfo)" v-if="exhibitInfo.collectStatus">{{ $t('common.collected') }}</button>
            <button class="shoucang2" @click="collent(exhibitInfo)" v-else>{{ $t('common.collectExhibits') }}</button>
          </div>
          <div class="exhibitor" @click="goDetail()">
            <div class="logo">
              <img :src="exhibitorInfo.comCover" alt="" v-if="exhibitorInfo.comCover" />
              <img src="../../static/占位-展商-列表.png" alt="" v-else />
            </div>
            <div class="exhi_title">
              <p>{{ exhibitorInfo.companyNameC }}</p>
              <p :title="exhibitorInfo.boothList" v-if="exhibitorInfo.boothList">
                {{ $t('common.boothNum1') }}&nbsp;&nbsp;<span
                  style="color: #333333;font-weight:600"
                  v-for="(item, index) in exhibitorInfo.boothList"
                  :key="index"
                  >{{ item }} &nbsp;</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 展品文字介绍 -->
      <div class="product_content">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '240px' }">{{ $t('exhibits.productIntroduce') }}</h3>
        <div v-html="lang == 'zh' ? exhibitInfo.exhibitsIntro : exhibitInfo.exhibitsIntroE" class="content"></div>
        <!-- 视频播放 -->
        <div class="vedio" v-if="exhibitInfo.column21">
          <video :src="`${exhibitInfo.column21.includes('https')?'':baseUrl}${exhibitInfo.column21}`" class="shipin" :poster="`${exhibitInfo.column20.includes('https')?'':baseUrl}${exhibitInfo.column20}`" controls="controls">
            your browser does not support the video tag
          </video>
        </div>
      </div>

      <!-- 产品参数 -->
      <div class="produce_table">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '190px' }">{{ $t('exhibits.productParameter') }}</h3>
        <!-- <div class="top">
          <el-row>
            <el-col :span="6"></el-col>
            <el-col :span="6">项目</el-col>
            <el-col :span="6">单位</el-col>
            <el-col :span="6">主要参数</el-col>
          </el-row>
        </div> -->
        <el-table v-html="exhibitInfo.techParam" class="tableDate"></el-table>
      </div>
      <!-- 产品宣传下载资料 -->
      <div class="download">
        <h3 class="hstyle" :style="{ width: lang == 'zh' ? '214px' : '410px' }">{{ $t('exhibits.productTravelBrochure') }}</h3>
        <div class="down_box">
          <div class="down_thend">
            <p>{{ $t('exhibits.infoName') }}</p>
            <p>{{ $t('common.options') }}</p>
          </div>
          <div class="down_file down_thend" v-for="(item, index) in exhibitInfo.exhibitsAttachList" :key="index">
            <p>{{ item.name }}</p>
            <p>
              <a v-if="item.url.substr(0,4) == 'http'" target="_blank" :href="item.url" download>{{ $t('common.download') }}</a>
              <a v-else  target="_blank" :href="baseUrl + item.url" download>{{ $t('common.download') }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 其他展品 -->
    <div class="other_product">
      <other-product :zsId="zsId" :zpId="id" :lang="lang" />
    </div>
    <foot-bottom />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import footBottom from '../../common/footBottom.vue';
import otherProduct from '../exhibitsItem/otherProduct.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { getExhibit, getExhibitor, collecExhibit } from '../../../api/exhibitProduct.js';
import * as tools from '../../../utils/roulink';
import { forMat } from '../../../utils/common.js';
export default {
  data() {
    return {
      baseUrl: forMat(),
      id: this.$route.query.id,
      zsId: '',
      tableData: [],

      swiperOption: {
        loop: true,
        autoplay: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
          bulletActiveClass: 'my-bullet-active',
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      //需要轮播的图片
      lunboImg: [],
      //下载资料
      downfile: [
        {
          title: 'CMM2-28Y煤矿用液压锚杆钻车产品介绍.docx',
          src: '',
        },
        {
          title: '山西天巨重工CMM2-28Y煤矿用液压锚杆钻车产品手册.pdf',
          src: '',
        },
      ],
      // 展品信息
      exhibitInfo: {
        techParam: '',
        exhibitsName: '', //展品名称
        column23: '', //展品型号
        seriesName: '', //展品系列
        column17: '', //展品类别
        exhibitsIntro: '', //展品介绍
        exhibitsIntroE: '', //展品介绍
        exhibitsAttachList: [], //展品宣传资料
      },
      exhibitorInfo: {
        companyNameC: '', // 中文名称
        comCover: '', //公司Logo
        boothList: [], //展位号
      },
      active: false,
      lang: '',
    };
  },

  components: {
    headTop,
    footBottom,
    swiper,
    swiperSlide,
    otherProduct,
  },

  computed: {},
  created() {
    this.getInitData();
    this.isActive();
    this.lang = localStorage.getItem('lang');
  },
  watch: {
    $route(to, from) {
      //监听相同路由下参数变化的时候，从而实现异步刷新
      this.id = this.$route.query.id;
      //重新获取数据
      this.getInitData();
      // this.isActive()
    },
  },
  methods: {
    isActive() {
      const key = window.location.href.includes('exhibItem_detail');
      // this.active[key] = true;
    },
    // 获取展商信息
    async getExhibitorInfo(id) {
      const params = { id };
      try {
        const { data } = await getExhibitor(params);
        this.exhibitorInfo = data.data;

        if(this.exhibitorInfo.comCover.indexOf("http")  == -1){
            this.exhibitorInfo.comCover= forMat() +   this.exhibitorInfo.comCover;
          }


        var arr = [];
        data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exhibitorInfo.boothList = arr;
      } catch (err) {
        console.log(err);
      }
    },
    // 获取展品信息
    async getInitData() {
      window, scrollTo(0, 0);
      this.lunboImg = [];
      const params = {
        id: this.id,
      };
      try {
        const { data } = await getExhibit(params);
        console.log(1,data);
        if (data.code === 200) {
          this.exhibitInfo = data.data;
          if (data.data?.exhibitsImg.includes(',')) {
            data.data?.exhibitsImg.split(',').map((item) => {
               if(item.indexOf("http")  == -1){
                  item= forMat() + item;
                }
              this.lunboImg.push({
                url: item,
              });
            });
          } else {
            let img = data.data?.exhibitsImg;
            if(img.indexOf("http")  == -1){
                img= forMat() + img;
            }
            this.lunboImg = [{ url: img }];
          }

          this.getExhibitorInfo(data.data.hzExhibitorId);
          this.zsId = data.data.hzExhibitorId;
        }
      } catch (err) {
        console.log(err);
      }
    },
    consult(item) {
      tools.login(1, item.id);
    },
    async collent(item) {
      // item.collectStatus = !item.collectStatus;
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
          this.getOtherExInfo();
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.msg,
          //   type: 'warning',
          // });
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 跳转展商详情
    goDetail() {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id: this.exhibitInfo.hzExhibitorId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  //    height: 2010px;
  margin-top: 120px;
  h3 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 28px;
    color: #006fb8;
    width: 152px;
    border-left: 3px solid #006fb8;
    border-right: 3px solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  ul li {
    text-decoration: none;
    list-style-type: none;
  }
  .content {
    width: 1270px;
    margin: 0 auto;
    .parduct_intr {
      display: flex;
      margin-top: 42px;
      .lunbo {
        width: 692px;
        height: 520px;
        // border: 1px solid red;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        img {
          width: 100%;
          max-height: 100%;
          // height: 424px;
          // margin-top: 48px;ss
        }
        .swiper-container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        .swiper-container .swiper-slide {
          width: 100%;
          line-height: 200px;
          //   background: yellowgreen;
          color: #000;
          font-size: 16px;
          text-align: center;
        }
        .swiper-button-prev {
          background-image: url('../../static/ico-leftprevnew.png');
          background-size: 100%;
          width: 40px;
          height: 40px;
          //background-origin:content-box;
        }
        .swiper-button-next {
          background-image: url('../../static/ico-rightNexnew.png');
          background-size: 100%;
          width: 40px;
          height: 40px;
        }
      }
      .introduce {
        width: 490px;

        margin-left: 86px;
        box-sizing: border-box;
        padding: 24px 0 0 0;

        .title {
          .titleContent {
            font-size: 30px;
            line-height: 37px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            width: fit-content;

            display: block;
            border: none;
            padding-bottom: 15px;
          }
          .border {
            width: 100%;
            height: 3px;
            background: #006fb8;
          }
        }

        p {
          margin-top: 20px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;

          color: #333333;
          overflow: hidden;
          text-overflow:ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .collent_btn {
          .shoucang {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #006fb8;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            margin: 18px 11px 0 0;
          }
          .shoucang:hover {
            background: #338cc6;
            cursor: pointer;
          }
          // .shoucang:active {
          //   background: #0064a6;
          // }
          .shoucang2 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            background: #fdd000;
            border-radius: 4px;
            /*   color: white; */
            color: #006fb8;
            font-size: 18px;
            //   margin: 22px 0 0 50px;
          }

          .shoucang2:hover {
            border: 1px solid transparent;
            background: #fdd933;
            cursor: pointer;
          }

          .shoucang3 {
            border: 1px solid transparent;
            width: 162px;
            height: 54px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            background: #ededed;
            border-radius: 4px;
          }
          .shoucang3:hover {
            border: 1px solid transparent;
            background: #ededed;
            cursor: pointer;
          }
        }
        .exhibitor {
          width: 489px;
          height: 136px;
          display: flex;
          margin-top: 95px;
          border: 1px solid #e0e0e0;
          cursor: pointer;
          .logo {
            width: 237px;
            height: 136px;
            //padding: 0 56px;
            box-sizing: border-box;
            border: 1px solid #e0e0e0;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 36px;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          .exhi_title {
            box-sizing: border-box;
            padding-left: 20px;
            flex: 1;
            p {
              margin-top: 20px;
              max-width: 230px;
            }
          }
        }
      }
    }
    .product_content {
      margin-top: 100px;
      .content {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 27px;
        margin-top: 27px;
        text-indent: 2em;
        p {
          text-indent: 2em;
          font-size: 18px !important;
          span {
            font-size: 18px !important;
          }
        }
      }
      .vedio {
        width: 800px;
        height: 450px;
        margin: 0 auto;
        margin-top: 42px;
        // border: 1px solid red;
      }
      .shipin {
        width: 100%;
        height: 450px;
      }
      p {
        text-indent: 2em;
      }
    }

    .produce_table {
      margin-top: 100px;
      .top {
        height: 40px;
        background: #006fb8;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        .el-row {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .grid-content {
          border-radius: 4px;
          min-height: 36px;
        }
        .row-bg {
          padding: 10px 0;
          background-color: #f9fafc;
        }
      }
    }
    //产品宣传下载资料
    .download {
      margin-top: 100px;
      margin-bottom: 90px;
      .hstyle {
        width: 214px;
      }
      .down_box {
        .down_thend {
          display: flex;
          height: 40px;
          /*    color: white; */
          color: #333333;
          background-color: #fdd000;
          align-items: center;
          padding: 0px 30px;
          justify-content: space-between;
          p :first-child {
            width: 800px;
          }
        }
        .down_file {
          background-color: white;
          color: #333;
          border-bottom: 1px solid #e0e0e0;
          height: 51px;
        }
        a {
          text-decoration: none;
          color: #006fb8;
        }
      }
    }
  }
  .other_product {
    padding: 103px 0;
    background: #f6f6f7;
  }
}
</style>
<style scoped>
.el-table >>> td {
  border-bottom: 1px solid #ebeef5;
  border-right: 0px;
  border-left: 0px;
}
.el-table >>> table {
  border: 0px;
}
.el-row >>> .el-col-6 {
  width: 25%;
  height: 100%;
  display: flex;
}
div[class*='el-col-'] {
  float: right;
}
/* .content>>>span{
  font-size: 18px !important;
}
.content>>>p{
  font-size: 18px !important;
} */
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(3n-1) {
  background: #e0e0e0;
}
.tableDate >>> tr:nth-child(2n) > td:nth-last-child(2n + 1) {
  background: #e0e0e0;
}
.tableDate >>> td:nth-child(1) {
  display: table-cell;
  text-align: center;
  align-items: center;
}
/* >>> .swiper-pagination-bullet.my-bullet-active {
  background: #fccf00 !important;
  opacity: 1;
} */
</style>
